import { Button, styled } from '@mui/material';

import { ReactComponent as Warning } from 'assets/icons/warning.svg';

export const ConfirmButton = styled(Button)({
	height: '44px',
	width: '215px',
	borderRadius: '8px',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	marginTop: '24px',
	backgroundColor: 'rgb(71, 134, 255)',
	color: 'rgb(255, 255, 255)',
	'&:hover': {
		backgroundColor: 'rgb(108, 158, 255)',
	},
});

export const CancelButton = styled(Button)({
	height: '44px',
	width: '215px',
	borderRadius: '8px',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	marginTop: '24px',
	backgroundColor: 'unset',
	border: '1px solid rgb(71, 134, 255)',
	color: 'rgb(71, 134, 255)',
	'&:hover': {
		borderColor: 'rgb(108, 158, 255)',
		backgroundColor: 'rgb(218, 231, 255)',
		color: 'rgb(108, 158, 255)',
	},
});

export const WarningIcon = styled(Warning)({
	'& path': {
		fill: '#4786FF',
	},
});
